export enum NumberStars {
  Zero = 0,
  One = 1,
  Two = 2,
  Three = 3,
  Fore = 4,
  Five = 5,
}
